<div class="modal-header">
  <h4 class="modal-title pull-left">Tax Returns / Financials</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="query">
    <div class="text">Is the Company's fiscal year end December 31?</div>

    <div class="actions" *ngIf="NOT_DEC === undefined">
      <button type="button" class="btn btn-rbv default wide" (click)="NOT_DEC = true">No</button>
      <button type="button" class="btn btn-rbv wide" (click)="NOT_DEC = false; FYE_SELECTED = true;INT_SELECTED = true;">Yes</button>
    </div>

    <div class="result" *ngIf="NOT_DEC === false">
      <span class="bold">Fiscal Year End</span> - {{thisYearDecFye | date:'MMMM d'}}
    </div>

    <div class="result" *ngIf="NOT_DEC === true">
      <button type="button" class="btn btn-rbv default wide">No</button>
      <button type="button" class="btn btn-rbv wide" (click)="NOT_DEC = false; FYE_SELECTED = true;INT_SELECTED = true;">Yes</button>
    </div>
  </div>

  <div class="query" *ngIf="NOT_DEC === true">
    <div class="text">Company’s Fiscal Year End.</div>

    <div class="actions">
      <div class="date-wrapper">
        <input class="date-field" #datePicker="bsDatepicker" bsDatepicker placeholder="Pick Date" [(ngModel)]="FYE_DATE"
               [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
               (ngModelChange)="FYE_SELECTED = true;INT_SELECTED = true;"/>
        <div class="icon-button" (click)="datePicker.show()">
          <fa name="fa fa-calendar"></fa>
        </div>
      </div>
    </div>
  </div>

  <div class="query" *ngIf="FYE_SELECTED === true">
    <div class="text">
      Company’s most recent financials.
      <br/><span class="font-italic small">(interim financial date)</span>
    </div>

    <div class="actions">
      <div class="date-wrapper">
        <input class="date-field" #datePicker="bsDatepicker" bsDatepicker placeholder="Pick Date" [(ngModel)]="INT_DATE"
               [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
               (ngModelChange)="INT_SELECTED = true"/>
        <div class="icon-button" (click)="datePicker.show()">
          <fa name="fa fa-calendar"></fa>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="onConfirm()" [disabled]="INT_SELECTED !== true">Accept</button>
</div>
